import React, { useEffect, useState } from "react";
import myLogo from "../../Assets/Logo/NYC-Logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoClose, IoSearch } from "react-icons/io5";
import { BsCart4 } from "react-icons/bs";
import { FaRegUser } from "react-icons/fa";
import { useAuthenticationContext } from "../../../Context/Authentication";
import "../../css/custom.css";
import "../../css/style.css";
import { useCartInventoryContext } from "../../../Context/Cache/CartInventoryContext";
import { useSearchContext } from '../../../Context/SetGlobalSearch';
import { LoadingScreen } from '../../LoadingScreen'
import { useTokenCallContext } from "../../../Context/TokenCall";
import { useMsal } from "@azure/msal-react";

const HeaderLogo = () => {
  const { instance } = useMsal();
  const { searchTerm, setSearchTerm, searchResults } = useSearchContext();
  const {setCurrentUrl} = useTokenCallContext()
  const location = useLocation();
  const { pathname } = location;
  const { cartProduct, handleAddToCartFromSearch } = useCartInventoryContext();
  const { screenSize } = useAuthenticationContext();
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate();
  const cartProductdetails = cartProduct || [];
  const [prevKey, setPrevKey] = useState('');
  const newUserValidation = localStorage.getItem("newUserValidation") === "true"
  const validNewCustomer = localStorage.getItem("validNewCustomer") === "true"
  const hasCartProducts = cartProduct && cartProduct.length > 0;
  const handleSearchOpen = () => {
    setIsSearchOpen(true);
  };
  const handleSearchClose = () => {
    setSearchTerm(""); // Clear search term on close
    setIsSearchOpen(true);
  };
  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const handleSearchSubmit = () => {
    console.log("Search term:", searchTerm);
    // Perform further actions with the search term here
  };

  useEffect(() => {
    sessionStorage.setItem("currentUrl", location.pathname);
    setCurrentUrl(location.pathname);
  }, [location.pathname, setCurrentUrl]);


  const handleLogout = () => {
    setIsLoading(true)
    caches.keys().then(names => {
      names.forEach(name => {
        caches.delete(name);
      });
    });
    setTimeout(() => {
      setIsLoading(false)
      // instance.logoutRedirect();
      window.location.reload();
    }, 3000);
    localStorage.clear();
    sessionStorage.clear();
    window.localStorage.setItem('clearSessionStorage', Date.now());
  };
  const [validSalesPerson, setValidSalesPerson] = useState(() => {
    const storedValidSalePerson = localStorage.getItem("validSalesPerson");
    return storedValidSalePerson === "true"; // Convert string 'true' or null to boolean
  });
  const [validNewPerson, setValidNewPerson] = useState(() => {
    const storedValidNewPerson = localStorage.getItem("newCustomer");
    return storedValidNewPerson === "true"; // Convert string 'true' or null to boolean
  });
  // const handlePaste = (e) => {
  //   e.preventDefault();
  //   const pastedText = e.clipboardData.getData('Text').trim();
  //   console.log("Pasted text:", pastedText);
  //   setSearchTerm(pastedText);
  //   const result = searchResults.find(item => item.nyc_upc === pastedText);
  //   console.log("Search Results", result);
  //   if (result) {
  //     handleAddToCartFromSearch(result);
  //     setTimeout(() => {
  //       handleSearchClose();
  //     }, 500);
  //   }
  // };
  const handleKeyDown = (e) => {
    console.log(`Key pressed: ${e.key}`);
    console.log("Previous Key: ", prevKey);
    if (prevKey == 'Enter') {
      handleSearchClose();
    }
    setPrevKey(e.key);
    if (e.key == 'Enter') {
      const pastedText = e.target.value;
      console.log("Pasted text:", pastedText);
      setSearchTerm(pastedText);
      console.log("search", searchResults)
      const result = searchResults.find(item => item.nyc_upc === pastedText);
      console.log("Search Results", result);
    }
    // console.log(`Key pressed: ${e.key} (code: ${e.code})`);
    //console.log(`Key modifier(s): Shift: ${e.shiftKey}, Ctrl: ${e.ctrlKey}, Alt: ${e.altKey}, Meta: ${e.metaKey}`);
  };

  return (
    <div className="header-middle-area pt-2" style={{ height: "87px" }}>
      {isLoading && <LoadingScreen />}
      <div className="" style={{ maxWidth: `${screenSize}px` }}>
        <div className="row align-items-center">
          <div className=" p-2 col-lg-2 flex justify-center ">
            <div>
              <Link to="home/inventory">
                <img src={myLogo} alt="brand logo" width="111px" />
              </Link>
            </div>
          </div>
          <div className="col-lg-7 flex justify-center nycfix-mb-resp-menu-options">
            <nav className="flex text-sm">
              <ul className="main-menu-top nycfix-mb-resp-list">
                <li className="nycfix-mb-resp-menu-items">
                  <Link
                    to="/home/inventory"
                    className={pathname === "/home/inventory" ? "active" : ""}
                  >
                    Inventory
                  </Link>
                </li>
                {/* <li className="nycfix-mb-resp-menu-items online-int">
                  <Link
                    to="/home/amazon-inventory"
                    className={
                      pathname === "/home/amazon-inventory" ? "active" : ""
                    }
                  >
                    Online Inventory
                  </Link>
                </li> */}
                {/* <li>
                  <Link
                    to="/home/best-seller"
                    className={pathname === "/home/best-seller" ? "active" : ""}
                  >
                    Best Seller
                  </Link>
                </li> */}
                <li className="nycfix-mb-resp-menu-items">
                  <Link
                    to="/home/incoming"
                    className={pathname === "/home/incoming" ? "active" : ""}
                  >
                    Incoming
                  </Link>
                </li>
                {/*<li className="nycfix-mb-resp-menu-items">
                  <Link
                    to="/home/atu"
                    className={pathname === "/home/atu" ? "active" : ""}
                  >
                    ATU
                  </Link>
                </li>*/}
                {/* <li className="nycfix-mb-resp-menu-items">
                  <Link
                    to="/home/replenishment"
                    className={
                      pathname === "/home/replenishment" ? "active" : ""
                    }
                  >
                    Replenishment
                  </Link>
                </li> */}
                {!validSalesPerson && !validNewPerson && (
                  <li className="nycfix-mb-resp-menu-items online-int">
                    <Link
                      to="/home/recent-orders"
                      className={
                        window.location.pathname === "/home/recent-orders"
                          ? "active"
                          : ""
                      }
                    >
                      Recent Offers/Order
                    </Link>
                  </li>
                )}

              </ul>
            </nav>
          </div>

          {(!newUserValidation) && (
            <div className="col-lg-3 nycfix-mb-resp-searchGrid">
              <div className="flex items-center justify-end">
                {/* Conditionally render the search bar if pathname is not /client-information or /home/recent-orders */}
                {(validNewCustomer || pathname !== "/home/recent-orders") && (
                  <div className={`relative flex ${isSearchOpen ? "open" : ""}`}>
                    <input
                      type="text"
                      placeholder="Search..."
                      className="border w-full border-gray-200 rounded-md pl-10 py-1 nyc-fix-searchbar"
                      value={searchTerm}
                      onChange={handleInputChange}
                      onFocus={() => setIsSearchOpen(true)}
                      onKeyDown={handleKeyDown}
                    />
                    <span
                      className="absolute left-3 top-1/2 text-lg transform -translate-y-1/2 text-gray-400 cursor-pointer nycfix-search-icon"
                      onClick={handleSearchSubmit}
                    >
                      <IoSearch />
                    </span>
                    <IoClose
                      className="close-icon text-red-600 absolute text-lg right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                      onClick={handleSearchClose}
                      style={{
                        display: isSearchOpen ? "block" : "none",
                      }}
                    />
                  </div>
                )}
                {/* Cart and Profile Menu */}
                <div className="cart">
                  <Link to="/home/cart">
                    <span className="cart-icon">
                      <BsCart4 />
                    </span>
                    {hasCartProducts && (
                      <span className="cart-count">
                        {cartProductdetails.length || 0}
                      </span>
                    )}
                  </Link>
                </div>
                <div className="profile-menu">
                  <button className="profile-btn nycfix-mb-resp-prof-btn">
                    <FaRegUser />
                  </button>
                  <div className="profile-content">
                    <Link to="/help-support">Help / Support</Link>
                    <Link onClick={handleLogout}>Logout</Link>
                  </div>
                </div>
              </div>
            </div>
          )}


        </div>
      </div>
    </div>
  );
};
export default HeaderLogo;